module.exports = __webpack_public_path__ + "assets/img/4.ae32a636.jpg";